import { AliasIpOperationConstant } from './Constants';

const AliasIpHelper = {};

/**
 * 内容默认居中显示，改为靠左显示
 * @return {{style: string}}
 */
const getClass = () => ({ style: 'text-align: left; word-break: break-all' });

export function AliasIpOperations(caseOps, target, param, type) {
  switch (parseInt(caseOps, 10)) {
    // 删除别名IP范围操作
    case AliasIpOperationConstant.DELETE:
      const h = target.$createElement;
      const params = {
        region: param.region,
        aliasIpId: param.aliasIpId,
        clientToken: Normal.getClientToken(),
      };
      target.$msgbox({
        title: target.$t('subnet.text.deleteAliasIp'),
        message:param.ipv6? h('p', getClass(), [
          h('span', null, target.$t('subnet.help.confirmToDeleteIpAliasRange', [param.cidr])),
        ]) :h('p', getClass(), [
          h('span', null, target.$t('subnet.help.confirmToDeleteIpv6AliasRange', [param.cidr])),
        ]) ,
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: target.$t('popHelper.text.sure'),
        cancelButtonText: target.$t('popHelper.text.cancel'),
      }).then(() => {
        Ajax.del('/api/cps/aliasIps', params)
          .then((res) => {
            if (res.data.success) {                    
                if (type === 'extensionNetwork') {
                  target.getAliasIpsListData(true, 'extensionNetwork');
                } else if (type === 'primaryNetwork') {
                  target.getAliasIpsListData(true, 'primaryNetwork');
                }
                target.$message.success(target.$t('privateNetInstance.operateSuccess'));
            }
          })
          .catch(async (err) => {
            const { response } = err.data;
            try {
              const json = await response.json();
              target.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          });
      });
  }
}

export default AliasIpHelper;



// WEBPACK FOOTER //
// ./src/common/AliasIpHelper.js